import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DatePipe } from '@angular/common'
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { FormGroup } from '@angular/forms';
import * as period from '.././../../../data/periodBet.json';
import { environment } from '../../../../../environments/environment';
import { RolesData } from '../../../../@core/interfaces/common/roles';
import { SalesMasterData } from '../../../../@core/interfaces/masters/salesmaster';
import { access } from '../../../../data/access-constants';
import { DateService } from '../service/date.service';

@Component({
  selector: 'ngx-common-patient-list',
  templateUrl: './common-patient-list.component.html',
  styleUrls: ['./common-patient-list.component.scss']
})
export class CommonPatientListComponent implements OnInit {
  protected readonly unsubscribe$ = new Subject<void>();
  @Input() accessFrom: string;
  private tenandId = localStorage.getItem("tenantId");
  private branchId = localStorage.getItem("branchId");
  private userId = parseInt(localStorage.getItem("userId"));
  @Output() action = new EventEmitter<any>();
  patientFlag: boolean=false;
  periodList: string[] = (period as any).default;
  periodListPatient = ["Between", "Today", "Yesterday", "This Week", "This Month", "This Year"];
  p: number=1;
  period: string = "";
  patientPeriod: string = "Today";
  filteredPatients:Array<any>=[];
  patienMobileSearch:string;
  fromDate: Date;
  toDate: Date;
  rangeDate: Date[];
  maxDate = new Date();
  patientUniqueList:Array<any>=[];
  compltedStatusList = [{ name: 'All', value: 'All', state: true }, { name: 'OP', value: 'OP', state: false }, { name: 'IP', value: 'IP', state: false }]
  allowClear: boolean = true;
  term: string;
  private apiUrl = environment.apiUrl;
  userAccessData: any;
  @Output() dataFetched = new EventEmitter<any[]>();
  @Output() dateRangeChanged = new EventEmitter<{ fromDate: Date; toDate: Date; patienMobileSearch: any; status: any;}>();

  constructor(public dateobj: DateService, public datepipe: DatePipe, protected salesservice: SalesMasterData, protected router: Router, protected rolesService: RolesData) {

  }

  ngOnInit(): void {
    this.onPatientSearch();
  }


  onActionClicked(actionType: string, rowData: any) {
      this.action.emit({actionToPerform: actionType, data: rowData});
  }


  onPatientListReset() {
    this.rangeDate = null;
    this.fromDate = null;
    this.toDate = null;
    this.patientFlag = false;
    this.patientPeriod="Today";
    this.onPatientSearch();
  }

  onPatientPeriodChange(event) {
    this.patientFlag = false;
    if (event[0]?.value == "Between") {
      this.patientFlag = true;
    }
  }

  patientprevclicked() {
    if (this.p > 1)
      this.p = this.p - 1
  }
  patientnextclicked() {
    if (this.p < (this.filteredPatients.length / 10)) {
      this.p = this.p + 1
    }
  }

  onStatusChange(changedStatus: any) {
    changedStatus.state = !changedStatus.state;
    if (changedStatus.value === 'All') {
      this.compltedStatusList.forEach((status) => {
        if (status.value !== 'All') status.state = false;
      });
    } else {
      this.compltedStatusList.find((status) => status.value === 'All')!.state =
        false;
    }

    this.applyFilters();
  }


  applyFilters() {
    const isAllSelected = this.compltedStatusList.find(
      (status) => status.value === 'All' && status.state
    );

    let filtered = [...this.patientUniqueList];
    let activeFilter: string = '';

    if (!isAllSelected) {
      const activeFilters = this.compltedStatusList
        .filter((status) => status.state && status.value !== 'All')
        .map((status) => status.value);
      if (activeFilters.length > 0) {
        filtered = filtered.filter((patient) =>
          activeFilters.includes(patient.status)
        );
      }

      activeFilter = this.compltedStatusList
        .filter((status) => status.state && status.value !== 'All')
        .map((status) => status.value)
        .join(','); 
    }

    if (this.patienMobileSearch?.trim()) {
      const term = this.patienMobileSearch.toLowerCase();
      filtered = filtered.filter(
        (patient) =>
          patient?.patientName.toLowerCase().includes(term) ||
          patient?.regNum.toString().includes(term) ||
          patient?.admNo.toString().includes(term) ||
          patient?.status.toLowerCase().includes(term)||
          patient?.mobile.toString().includes(term)
      );
    }

    this.filteredPatients = filtered;
    this.dataFetched.emit(this.filteredPatients);
    this.dateRangeChanged.emit({
      fromDate: this.fromDate,
      toDate: this.toDate,
      patienMobileSearch : this.patienMobileSearch,
      status: isAllSelected ? 'All' : activeFilter,
    });
  }
  onPatientSearch() {
    var date = this.dateobj.currentDate();
    if (this.patientPeriod != "" && this.patientPeriod != "Between") {
      switch (this.patientPeriod) {
        case 'Today':
          this.rangeDate = null;
          this.fromDate = date;
          this.toDate = date;
          break;
        case 'Yesterday':
          date.setDate(date.getDate() - 1);
          this.fromDate = date;
          this.toDate = date;
          break;
        case 'This Week':
          var today = new Date(date.getFullYear(), date.getMonth(), date.getDate());
          this.fromDate = new Date(today.setDate(today.getDate() - today.getDay()));
          this.toDate = date;
          break;
        case 'This Month':
          this.fromDate = new Date(date.getFullYear(), date.getMonth(), 1);
          this.toDate = date;
          break;
        case 'This Year':
          this.fromDate = new Date(date.getFullYear(), 0, 1);
          this.toDate = date;
          break;
        case 'All':
          this.fromDate = null;
          this.toDate = date;
          break;
        default:
          break;
      }
    }
    let searchData = {
      fromDate: this.dateobj.utcFromDate(this.fromDate),
      toDate: this.dateobj.utcToDate(this.toDate),
    }
    this.salesservice.searchList(`salesMasterMst/${this.tenandId}/${this.branchId}/GetAllPatientsDet`, searchData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      var val = [];
      val = Array.from(new Set(data.appointmentDet.concat(data.admissionDet, data.regDet)));
      let uniqueArray = val.filter((item, index) => {
        return index === val.findIndex(obj => obj.regId === item.regId);
      });
      this.patientUniqueList = uniqueArray;
      this.applyFilters();
    }, (error) => {
    }, () => {
    });
  }

}
